import { Component, OnInit } from '@angular/core';
import { Meta, Title, DomSanitizer } from '@angular/platform-browser';
import { MetaServiceService } from '../../meta-service.service';

@Component({
  selector: 'app-itandbanking',
  templateUrl: './itandbanking.component.html',
  styleUrls: ['./itandbanking.component.scss']
})
export class ItandbankingComponent implements OnInit {
  safeURL; //youTube Video URL // 

  constructor(
    private meta: Meta, 
    private title: Title, 
    private _sanitizer: DomSanitizer,
    private metaService: MetaServiceService) {

    //  SEO Meta Description
    this.meta.addTags([
      { name: 'description', content: 'Cview-Survey is here for you  to provide an ITES survey solution from which you can identify the strengths and weaknesses of your employees, processes, service, and policies.' },
      { name: 'author', content: 'CViewSurvey' },
      { name: 'keywords', content: 'ITES survey , IT survey solution , Effective solution , Feedback solution , Survey for Employes , Collect data anywhere , Customer satisfaction feedback , 360° assessment' }
    ]);

    this.setTitle('ITES and IT Satisfaction Survey | IT Survey | Effective Feedback Solution');
    // End SEO Meta Description

    // You Tube Video Description
    this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/EsPq62yE3AE?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1');
    // End You Tube Video Description

  }


  // SEO Page Title Description
  public setTitle(newTitle: string) {
    this.title.setTitle(newTitle);
  }
  // SEO Page Title Description


  ngOnInit(): void {
     // for create canonical link 
     this.metaService.createCanonicalURL();
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
